import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { AButton } from '../../atoms';
import { OProducts } from '../';

export default class OProductsLoadMore extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loadLimit: 4,
		};
	}

	bindHandles() {
		this.handleLoadMore = this.handleLoadMore.bind(this);
	}

	handleLoadMore() {
		this.setState(prev => ({ loadLimit: prev.loadLimit + 4 }));

		if (this.props.loadMore) {
			this.props.loadMore();
		}
	}

	render() {
		let loadMoreButton;

		if (this.props.items.length > this.state.loadLimit) {
			loadMoreButton = (
				<AButton
					value={this.props.buttonValue}
					type="ghost"
					className="align-right"
					onClick={this.handleLoadMore}
				/>
			);
		}

		return (
			<section className={`o-product-accessoires ${this.props.className}`}>
				<h2>
					<FormattedMessage id={this.props.title} defaultMessage="" />
				</h2>
				<OProducts
					href={this.props.href}
					items={this.props.items.slice(0, this.state.loadLimit)}
				/>
				{loadMoreButton}
			</section>
		);
	}
}

OProductsLoadMore.propTypes = {
	items: PropTypes.array,
	loadMore: PropTypes.func,
	title: PropTypes.string,
	buttonValue: PropTypes.string,
	className: PropTypes.string,
	href: PropTypes.string,
};

OProductsLoadMore.defaultProps = {
	title: '',
	buttonValue: '',
	className: '',
	href: '',
	loadMore: undefined,
	items: [],
};



// WEBPACK FOOTER //
// ./src/components/organisme/product/_organisme.products-load-more.js